import { render } from "./TipMatchDynamics.vue?vue&type=template&id=9c07e6e4&scoped=true"
import script from "./TipMatchDynamics.vue?vue&type=script&lang=js"
export * from "./TipMatchDynamics.vue?vue&type=script&lang=js"

import "./TipMatchDynamics.vue?vue&type=style&index=0&id=9c07e6e4&scoped=true&lang=scss"

import exportComponent from "/Users/cp/Code/betslip/BetslipPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c07e6e4"]])

export default __exports__